import API from "@aws-amplify/api";
import { getTokenByAgent } from "../../../../app/src/graphql/queries";
import envConfig from "../../../envConfig";
import secureRequest from "@toothfairy/shared-api/secureAPI";
import client from "@toothfairy/shared-api/src/Common/client";

const getToken = async (agentId) => {
  return API.graphql({
    query: getTokenByAgent,
    variables: { id: agentId },
    authMode: "API_KEY",
    authToken: envConfig.REACT_APP_GRAPHQL_TOKEN,
  });
};

const getState = async (workspaceid) => {
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/workspaces/state/${workspaceid}`;
  return secureRequest(client, "GET", url, null, null, false, {});
};

export default {
  getToken: getToken,
  getState: getState,
};
